// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable, Inject, EventEmitter } from '@angular/core';
import { defaultTheme, testTheme, Theme, themes } from './themes';

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    themeChange = new EventEmitter<Theme>();
    public themes: Theme[] = themes;
    public theme: string;

    getTheme(name: string) {
        const theme = this.themes.find((t) => t.name === name);

        if (!theme) {
            throw new Error(`Theme not found: '${name}'`);
        }
        return theme;
    }

    getActiveTheme() {
        return this.theme ? this.getTheme(this.theme) : this.getTheme('default');
    }

    getProperty(propName: string) {
        return this.getActiveTheme().properties[propName];
    }

    setTheme(name: string) {
        this.theme = name;
        this.themeChange.emit(this.getActiveTheme());
    }

    registerTheme(theme: Theme) {
        this.themes.push(theme);
    }

    updateTheme(name: string, properties: { [key: string]: string }) {
        const theme = this.getTheme(name);
        theme.properties = {
            ...theme.properties,
            ...properties,
        };

        if (name === this.theme) {
            this.themeChange.emit(theme);
        }
    }
}
